import { css as t } from "@microsoft/fast-element";
import { display as i } from "@matrix42/fast-foundation";
import { normalize as e } from "../../common/normalize.js";
import { designTokens as o } from "../../design-tokens.js";
import { typography as n } from "../../styles/typography.js";
const d = (r) => t`
  ${e}
  ${i("inline-flex")}
  .control {
    /* Base */
    text-decoration: none;
    /* Layout */
    display: inline-flex;
    padding: 0 ${o.spacing[2]};
    /* Style */
    color: ${o.color.primary[100]};
    border-radius: ${o.borderRadius.xs};
    /* Transitions */
    transition: background-color ${o.transition.fast},
      color ${o.transition.fast};
  }

  .control:hover {
    /* Style */
    background-color: ${o.color.primary[30]};
  }

  .control:focus-visible {
    /* Style */
    background-color: ${o.color.primary[30]};
    outline-color: ${o.color.black};
    /* TODO: Use design tokens */
    outline-offset: ${o.borderWidth.xs};
  }

  .control:active {
    /* Style */
    color: ${o.color.primary[500]};
    background-color: ${o.color.primary[30]};
  }

  :host([disabled]) .control,
  .control[aria-current='page'] {
    /* Base */
    cursor: default;
    pointer-events: none;
    /* Style */
    color: ${o.color.neutral[100]};
    background-color: ${o.color.neutral[30]};
  }

  .content {
    /* Typography */
    ${n("p", "semibold")}
  }

  .separator {
    /* Layout */
    padding: ${o.spacing[1]} 0;
    /* Style */
    color: ${o.color.neutral[70]};
  }

  ${r.prefix}-icon,
  ::slotted(${r.prefix}-icon) {
    /* Layout */
    width: ${o.iconSize.xs} !important;
    height: ${o.iconSize.xs} !important;
    /* Style */
    color: inherit;
  }
`;
export {
  d as breadcrumbStyles
};
